import Api from "~/service/Api";

class SupportRepository {
  getCountries() {
    return Api.get(`/support/country`);
  }

  getCountryRegions(country) {
    return Api.get(`/support/country/${country}`);
  }
}

export default SupportRepository;
